import React from 'react';
import PropTypes from 'prop-types';
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {createCmsSpecialtyOptions} from "../../../helpers/utils";
import {useForm} from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import FormModal from "../../../components/common/modals/FormModal";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";
import {allCmsSpecialtiesDropdown} from "../../../relay/Fragments";

const NewPractitionerLocationCmsSpecialtyModal = ({showModal, onClose, practitionerLocationId, allCmsSpecialties}) => {
    const mutation = graphql`
        mutation NewPractitionerLocationCmsSpecialtyModalMutation(
            $practitionerLocationId: ID!
            $cmsSpecialtyId: ID!
            $effectiveFrom: DateOnly!
            $effectiveTo: DateOnly!
        ) {
        practitionerLocation {
            createCmsSpecialty(input: {
                    practitionerLocationId: $practitionerLocationId
                    cmsSpecialtyId: $cmsSpecialtyId
                    effectiveFrom: $effectiveFrom
                    effectiveTo: $effectiveTo
                }) {
                    practitionerLocationCmsSpecialty {
                        id
                        practitionerLocation {
                            cmsSpecialties {
                            ...PractitionerLocationCmsSpecialties_CmsSpecialties
                        }}}}}}`;
    
    const [commitMutation, isInFlight] = useMutation(mutation);

    const cmsSpecialties = createCmsSpecialtyOptions(useFragment(allCmsSpecialtiesDropdown, allCmsSpecialties));
    
    const defaultValues = {
        ...newBandDefaultValues,
        practitionerLocationId: practitionerLocationId,
        cmsSpecialtyId: ''
    };

    const schema = bandedSchema.shape({
        cmsSpecialtyId: yup.string().required("CMS Specialty is required"),
    });

    const methods = useForm({values: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({
            variables: {...data},
            onCompleted: (data) => {
                if (data.practitionerLocation?.createCmsSpecialty?.practitionerLocationCmsSpecialty) {
                    toast.success("CMS Specialty created");
                    methods.reset();
                    onClose();
                }
            }
        });
    };

    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   title={"New CMS Specialty"}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormSelect options={cmsSpecialties} controlId={"cmsSpecialtyId"} label={"CMS Specialty"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    );
};

NewPractitionerLocationCmsSpecialtyModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    practitionerLocationId: PropTypes.string.isRequired,
    cmsSpecialties: PropTypes.array.isRequired,
};

export default NewPractitionerLocationCmsSpecialtyModal;